module.exports = __webpack_public_path__ + "img/fondo---1.ed452a92.jpg";